// @flow
import * as React from 'react';
import styled from 'styled-components';
import RaisedButton from 'material-ui/RaisedButton';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { openSnackbar } from 'common/modules/ui/actions/uiActions';
import TitledCard from 'common/components/cards/TitledCard';
import RadioConfigurationStep from 'common/domain/RadioConfigurationStep';
import { getStation, getToken } from 'statsradio/modules/authentication/session/selectors/sessionSelectors';
import type { PlayerConfigurationData, Player, StatsRadioPlayerData } from '../domain/PlayerConfiguration';
import { INITIAL_DATA } from '../domain/PlayerConfiguration';
import ActionBar from '../components/ActionBar';
import RadioAnalyticsConfiguration from './playerConfigurationForm/RadioAnalyticsConfiguration';
import StatsRadioPlayerConfiguration from './playerConfigurationForm/StatsRadioPlayerConfiguration';
import { getStatsRadioPlayerData } from '../selectors/radioConfigurationSelectors';
import RadioConfigurationAPI from '../services/RadioConfigurationAPI';

const Wrapper = styled.div`
  padding: ${({ theme }) => theme.metrics.margin}px;
`;

const Text = styled.div`
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: ${({ theme }) => theme.fonts.style.small.fontSize}px;
  margin-bottom: ${({ theme }) => theme.metrics.margin}px;
`;

type Props = {
  actions: {
    openSnackbar: (type: string, message: string) => any,
  },
  apiToken: string;
  t: any;
  theme?: Object;

  statsRadioPlayer: StatsRadioPlayerData;
  stepData: PlayerConfigurationData;
  radioCallSign: string;

  onNextStep: () => any;
  onSaveStep: (step: RadioConfigurationStep) => any;
}

type State = {
  data: PlayerConfigurationData;
}
class PlayerConfigurationForm extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      data: INITIAL_DATA,
    };
  }

  componentWillMount() {
    this.setState({ data: this.props.stepData });
  }

  onChangePlayer = (player: Player) => {
    this.setState({
      data: {
        statsRadioPlayer: this.props.statsRadioPlayer,
        player: player,
      },
    });
  }

  onSaveStep = async () => {
    const data: PlayerConfigurationData = {
      player: this.state.data.player,
      statsRadioPlayer: this.props.statsRadioPlayer,
    };

    const backgroundImage = data.statsRadioPlayer.theme.backgroundImage;
    if (backgroundImage && backgroundImage.preview) {
      data.statsRadioPlayer.theme.backgroundImage = await this.uploadImage('banner', backgroundImage);
    }

    const logo = data.statsRadioPlayer.stationInformation.logo;
    if (logo && logo.preview) {
      data.statsRadioPlayer.stationInformation.logo = await this.uploadImage('logo', logo);
    }

    const step = RadioConfigurationStep.of('PLAYER', data);
    this.props.onSaveStep(step);
  }

  async uploadImage(imageType: string, image: any) {
    const { actions, apiToken, radioCallSign, t } = this.props;
    let url;

    try {
      url = await RadioConfigurationAPI.uploadPlayerImage(radioCallSign, apiToken, imageType, image);
    } catch (error) {
      actions.openSnackbar('error', t('playerImageUploadError', { imageType: t(imageType).toLowerCase() }));
    }

    return url;
  }

  render() {
    const { t, radioCallSign } = this.props;
    const { player, statsRadioPlayer } = this.state.data;

    return (
      <div>
        <TitledCard noPadding title={t('installationAndConfiguration')}>
          <Wrapper>
            <Text>{t('selectStreamConfiguration')}</Text>
            <div className="row">
              <div className="col-lg-4 col-xs-5">
                <RaisedButton fullWidth primary={player === 'STATSRADIO'} label={t('statsRadioPlayer')} onClick={() => this.onChangePlayer('STATSRADIO')} />
              </div>
              <div className="col-lg-3 col-xs-4">
                <RaisedButton fullWidth primary={player === 'CUSTOM'} label={t('script')} onClick={() => this.onChangePlayer('CUSTOM')} />
              </div>
            </div>
          </Wrapper>
          {player === 'CUSTOM' &&
            <RadioAnalyticsConfiguration callSign={radioCallSign} />
          }
          {player === 'STATSRADIO' &&
            <StatsRadioPlayerConfiguration
              data={statsRadioPlayer}
            />
          }
        </TitledCard>
        <ActionBar onActionClick={this.props.onNextStep} actionText={t('next')}>
          <RaisedButton
            label={t('save')}
            primary
            type="submit"
            onClick={this.onSaveStep}
          />
        </ActionBar>
      </div>
    );
  }
}

function mapStateToProps(state: *) {
  return {
    apiToken: getToken(state),
    radioCallSign: getStation(state),
    statsRadioPlayer: getStatsRadioPlayerData(state),
  };
}

function mapDispatchToProps(dispatch: *) {
  return {
    actions: bindActionCreators({ openSnackbar }, dispatch),
  };
}

export default translate('radioConfiguration')(connect(mapStateToProps, mapDispatchToProps)(PlayerConfigurationForm));



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/PlayerConfigurationForm.js